import { Head } from 'components/Head';
import { MainLayout } from 'components/Layout';
import { useEffect } from 'react';

export const CSAE = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // change to 'auto' if you want instant
    });
  }, []);
  return (
    <MainLayout
      title="CSAE Policy | Fundo"
      description="Fundo’s policy on Child Sexual Abuse and Exploitation (CSAE), reporting, and enforcement."
    >
      <section className="mx-auto max-w-3xl py-20">
        {/* Header */}
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-[#8b5e3c]">
            Safety & Compliance
          </p>

          <h1 className="mt-4 font-serif text-5xl leading-[0.95] tracking-[-0.04em] text-[#1b140f]">
            Child Safety & CSAE Policy
          </h1>

          <p className="mt-6 text-[#4f4034] leading-8">
            Fundo is committed to maintaining a safe environment for all users. We have zero
            tolerance for any form of child sexual abuse or exploitation (CSAE).
          </p>
        </div>

        {/* Zero Tolerance */}
        <div className="mt-10 rounded-[1.75rem] border border-red-200 bg-red-50 p-8">
          <h2 className="font-semibold text-red-700 text-lg">Zero tolerance policy</h2>

          <p className="mt-4 text-sm text-red-800 leading-7">
            Any content, behavior, or interaction that involves the sexual exploitation or abuse of
            minors is strictly prohibited on Fundo. This includes but is not limited to:
          </p>

          <ul className="mt-4 list-disc list-inside text-sm text-red-800 space-y-2">
            <li>Sharing or requesting explicit content involving minors</li>
            <li>Grooming, solicitation, or inappropriate communication with minors</li>
            <li>Any attempt to exploit, harm, or endanger children</li>
          </ul>
        </div>

        {/* Reporting */}
        <div className="mt-10 rounded-[1.75rem] border border-[#1b140f]/10 bg-white/60 p-8 backdrop-blur-md">
          <h2 className="font-semibold text-[#1b140f] text-lg">Reporting violations</h2>

          <p className="mt-4 text-sm text-[#4f4034] leading-7">
            If you encounter any content or behavior that violates this policy, report it
            immediately. You can do so by contacting us directly.
          </p>

          <div className="mt-4 text-sm text-[#4f4034]">
            <p>
              Email: <span className="font-medium text-[#1b140f]">fundofarmer@gmail.com</span>
            </p>
          </div>
        </div>

        {/* Enforcement */}
        <div className="mt-10 rounded-[1.75rem] border border-[#1b140f]/10 bg-white/60 p-8 backdrop-blur-md">
          <h2 className="font-semibold text-[#1b140f] text-lg">Enforcement actions</h2>

          <ul className="mt-4 list-disc list-inside text-sm text-[#4f4034] space-y-2 leading-7">
            <li>Immediate suspension or permanent banning of accounts</li>
            <li>Removal of offending content</li>
            <li>Reporting to relevant law enforcement authorities</li>
          </ul>
        </div>

        {/* Cooperation */}
        <div className="mt-10 rounded-[1.75rem] border border-[#1b140f]/10 bg-[#1b140f] p-8 text-white">
          <h3 className="font-semibold text-lg">Cooperation with authorities</h3>

          <p className="mt-4 text-sm text-white/80 leading-7">
            Fundo fully cooperates with law enforcement and child protection agencies in the
            investigation and prosecution of CSAE-related offenses.
          </p>
        </div>

        {/* Final Note */}
        <div className="mt-10 text-sm text-[#4f4034] leading-7">
          <p>
            Protecting children is a shared responsibility. We encourage all users to remain
            vigilant and report any suspicious or harmful activity.
          </p>
        </div>
      </section>
    </MainLayout>
  );
};
